<template>
  <div class="container">
    <div class="inside-banner">
      <!-- ElementUI轮播图 -->
      <el-carousel
          class="banner-carousel"
          indicator-position="none"
          loop
          autoplay
          arrow="never"
          ref="carouselRef"
      >
        <el-carousel-item v-for="(item, index) in topImgList" :key="index">
          <img
              :src="item.src"
              :alt="item.title || '轮播图'"
              class="carousel-img"
              @load="handleImgLoad($event)"
          />
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="container-content">
      <!-- 梯形+年份-描述的父容器 -->
      <div class="year-container">
        <!-- 梯形 -->
        <div class="trapezoidal"></div>
        <!-- 年份-描述列表（每个项包含年份+对应描述） -->
        <div class="year-desc-list">
          <div class="year-desc-item" v-for="(year,idx) in yearList" :key="idx">
            <!-- 年份标签 -->
            <div class="year-item">{{ year.year }}</div>
            <!-- 年份对应的描述 -->
            <div class="desc-text">{{ year.content  }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getImgList } from "@/api/home";
import { ImageTypeEnum } from "@/enums/imageTypeEnum";

export default {
  name: "CaseBanner",
  data() {
    return {
      loading: false,
      topImgList: [],
      imgRatio: 0,
      yearList:[
        {
          year: '2026',
          content: '成功举办第一届青少年中式台球星途联赛'
        },
        {
          year: '2025',
          content: '璟点台球器材直营店网络稳步拓展，POISON 毒药球杆新品发布，正式生产销售美洲豹台球桌，成功举办第二届CBSA中式台球中国公开赛总决赛，璟点集团台球产业园同步完成扩建'
        },
        {
          year: '2024',
          content: '成功举办第一届 CBSA 中式台球中国公开赛总决赛，璟点文体旅项目与东戴河管委会签订正式协议，璟点品牌成为央视国潮臻品馆上榜品牌，且璟点台球桌及台球器材远销海外'
        },
        {
          year: '2023',
          content: '璟点集团台球产业园扩建至 8 万余平米，璟点台球桌签约潘晓婷，同时中国台球协会官方宣布璟点承办 CBSA 中式台球中国公开赛'
        },
        {
          year: '2022',
          content: '东戴河璟点集团台球产业园落地，三家自有工厂（复合材料、台球杆、台球桌）搬迁至璟点集团台球产业园，整合三家石板、石材厂，成立联硕石材厂'
        },
        {
          year: '2021',
          content: '投资成立北京璟点高科科技有限公司，同时投资九江创晟台球桌石板工厂'
        },
        {
          year: '2020',
          content: '正式生产销售璟点品牌台球桌，璟点碳纤维复合材料产品正式投产，全面推出璟点全国级别系列赛事，且北京新璟体育传媒有限公司成立'
        },
        {
          year: '2019',
          content: '签约 9 球世界冠军刘海涛，启用秦皇岛山海关办公区，同时璟点台球杆产品正式投产'
        },
        {
          year: '2018',
          content: '中国区全权代理美洲豹品牌，启动京东、天猫旗舰店，且拥有 100 家线上合作伙伴'
        },
        {
          year: '2017',
          content: '中国区全权代理环球品牌，同时璟点全国器材连锁店突破 50 家'
        },
        {
          year: '2016',
          content: '璟点台球器材超市全国连锁项目启动，且璟点首家连锁器材店落户山西太原'
        },
        {
          year: '2009-15',
          content: '台球俱乐部运营'
        }
      ]
    };
  },
  created() {
    this.getBannerList();
  },
  methods: {
    async getBannerList() {
      try {
        this.loading = true;
        const res = await getImgList(ImageTypeEnum.MAJOR_EVENT_LIST.value);
        const dataList = res.data || [];
        this.topImgList = dataList.filter(
            (item) => item.classify === ImageTypeEnum.MAJOR_EVENT_LIST.value && item.src
        );
      } catch (error) {
        console.error("获取轮播图失败：", error);
        this.$message?.error("轮播图加载失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
    handleImgLoad(e) {
      const img = e.target;
      if (!this.imgRatio) {
        this.imgRatio = img.naturalWidth / img.naturalHeight;
        const carouselEl = this.$refs.carouselRef?.$el;
        if (carouselEl) {
          carouselEl.style.aspectRatio = this.imgRatio;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
// 统一盒模型
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.container {
  position: relative;
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
}

// Banner容器
.inside-banner {
  position: relative;
  margin-top: 100px;
  width: 100%;
  overflow: hidden;

  // 平板/小屏电脑：769px-1199px
  @media (min-width: 769px) and (max-width: 1199px) {
    margin-top: 60px;
  }
  // 移动端：≤768px 【优化】
  @media (max-width: 768px) {
    margin-top: 60px; // 进一步减少顶部间距
  }
  @media (max-width: 480px) {
    margin-top: 40px; // 手机端更紧凑
  }
}

// 轮播图容器
.banner-carousel {
  width: 100%;
  min-height: 150px;

  // 平板/小屏电脑：769px-1199px
  @media (min-width: 769px) and (max-width: 1199px) {
    min-height: 145px;
  }
  // 移动端：≤768px 【优化】
  @media (max-width: 768px) {
    min-height: 100px; // 降低最小高度
  }
  @media (max-width: 480px) {
    min-height: 80px; // 手机端更矮
  }

  :deep(.el-carousel__container) {
    height: 100% !important;
  }

  :deep(.el-carousel-item) {
    height: 100% !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

// 轮播图图片
.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  max-width: 100%;
  max-height: 100%;
}

.container-content {
  position: relative;
  margin: 0 auto;
  width: 80%;
  padding: 100px 0;

  // 平板/小屏电脑：769px-1199px
  @media (min-width: 769px) and (max-width: 1199px) {
    width: 88%;
    padding-top: 85px;
  }
  // 移动端：≤768px 【优化】
  @media (max-width: 768px) {
    width: 92%; // 几乎占满屏幕，减少留白
    padding-top: 40px; // 大幅减少顶部间距
  }
  @media (max-width: 480px) {
    width: 95%;
    padding-top: 30px;
  }
}

// 梯形+年份-描述的父容器
.year-container {
  display: flex;
  align-items: flex-start;

  // 平板/小屏电脑：769px-1199px
  @media (min-width: 769px) and (max-width: 1199px) {
    align-items: flex-start;
    gap: 15px;
  }
  // 移动端：≤768px 【核心修改：取消左右布局，改为垂直布局】
  @media (max-width: 768px) {
    flex-direction: column; // 垂直排列（梯形在上，列表在下）
    align-items: center; // 整体居中
    gap: 20px; // 梯形和列表之间的间距
  }
}

// 梯形样式
.trapezoidal {
  width: 10px;
  height: 750px;
  transform: perspective(150px) rotateX(5deg) scaleY(2);
  transform-origin: bottom;
  background: #f6c279;
  border-radius: 8px;
  backface-visibility: hidden;
  transform-style: preserve-3d;

  // 平板/小屏电脑：769px-1199px
  @media (min-width: 769px) and (max-width: 1199px) {
    height: 720px;
    transform: perspective(130px) rotateX(5deg) scaleY(1.9);
  }
  // 移动端：≤768px 【核心修改：适配垂直布局】
  @media (max-width: 768px) {
    width: 80px; // 横向变宽，纵向变短
    height: 10px; // 从竖条改为横条
    transform: none; // 取消3D效果，避免移动端变形
    border-radius: 4px;
  }
  @media (max-width: 480px) {
    width: 60px;
    height: 8px;
  }
}

// 年份-描述列表
.year-desc-list {
  height: 750px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  flex-shrink: 0;
  margin-left: 20px;

  // 平板/小屏电脑：769px-1199px
  @media (min-width: 769px) and (max-width: 1199px) {
    height: 720px;
    margin-left: 18px;
    justify-content: space-between;
    padding: 10px 0;
  }
  // 移动端：≤768px 【核心修改：适配垂直布局】
  @media (max-width: 768px) {
    height: auto; // 取消固定高度，自适应内容
    width: 100%; // 占满容器宽度
    margin-left: 0; // 取消左边距
    justify-content: flex-start; // 从上到下排列
    gap: 15px; // 年份项之间的间距
    padding: 0 5px;
  }
  @media (max-width: 480px) {
    gap: 12px;
  }
}

// 单个年份-描述项
.year-desc-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;

  // 平板/小屏电脑：769px-1199px
  @media (min-width: 769px) and (max-width: 1199px) {
    gap: 9px;
  }
  // 移动端：≤768px 【优化排版】
  @media (max-width: 768px) {
    flex-direction: row; // 保持横向（年份+描述），不换行
    align-items: flex-start; // 顶部对齐，更美观
    gap: 8px;
  }
  @media (max-width: 480px) {
    gap: 6px;
  }
}

// 年份标签样式
.year-item {
  position: relative;
  width: 80px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  background: #f6c279;
  color: #000;
  border-radius: 4px 0 0 4px;
  flex-shrink: 0;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: -20px;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    border-left: 20px solid #f6c279;
  }

  // 平板/小屏电脑：769px-1199px
  @media (min-width: 769px) and (max-width: 1199px) {
    width: 75px;
    height: 38px;
    line-height: 38px;
    font-size: 15px;
    &::after {
      right: -19px;
      border-top: 19px solid transparent;
      border-bottom: 19px solid transparent;
      border-left: 19px solid #f6c279;
    }
  }
  // 移动端：≤768px 【缩小尺寸】
  @media (max-width: 768px) {
    width: 60px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    &::after {
      right: -15px;
      border-top: 15px solid transparent;
      border-bottom: 15px solid transparent;
      border-left: 15px solid #f6c279;
    }
  }
  @media (max-width: 480px) {
    width: 50px;
    height: 26px;
    line-height: 26px;
    font-size: 12px;
    &::after {
      right: -13px;
      border-top: 13px solid transparent;
      border-bottom: 13px solid transparent;
      border-left: 13px solid #f6c279;
    }
  }
}

// 描述文本样式
.desc-text {
  font-size: 16px;
  line-height: 1.6;
  color: #333;
  flex: 1;
  min-width: 0;
  padding-left: 50px;

  // 平板/小屏电脑：769px-1199px
  @media (min-width: 769px) and (max-width: 1199px) {
    font-size: 15px;
    line-height: 1.55;
    padding-left: 45px;
  }
  // 移动端：≤768px 【核心优化：取消左内边距，适配垂直布局】
  @media (max-width: 768px) {
    font-size: 13px;
    line-height: 1.4;
    padding-left: 20px; // 取消左侧padding，节省空间
    margin-left: 0; // 取消左侧margin
  }
  @media (max-width: 480px) {
    font-size: 12px;
    line-height: 1.3;
  }
}
</style>